const GENDER = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'NB', label: 'Non-Binary' },
  { value: 'T', label: 'Transgender' },
  { value: 'O', label: 'Others' },
]

export default GENDER
